module.exports = __webpack_public_path__ + "static/media/schedule_structure_change_period_name.51f288a1.mov";